import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../navbar";
import Footer from "../footer";
import DashBoardHeader from "../dashboard-header";
import AdminDashboardHeader from "../../admin-ui/dashboard_admin_header";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const blockRoutes = [
    "/login",
    "/Login",
    "/signup",
    "/password",
    "/admin-login",
  ];

  // User-specific routes
  const checkDashboardRoute = [
    "/settings",
    "/queries",
    "/dashboard",
    "/view_response",
    "/query_details",
  ];

  // Admin-specific routes
  const adminDashboardRoute = ["/admin-dashboard", "/admin-queries-management"];

  return (
    <>
      {blockRoutes.includes(location.pathname) ? (
        <main>{children}</main>
      ) : checkDashboardRoute.includes(location.pathname) ? (
        <>
          <DashBoardHeader />
          <main>{children}</main>
        </>
      ) : adminDashboardRoute.includes(location.pathname) ? (
        <>
          <AdminDashboardHeader />
          <main>{children}</main>
        </>
      ) : (
        <>
          <Navbar />
          <main>{children}</main>
          <Footer />
        </>
      )}
    </>
  );
};

export default Layout;
